import React from "react";
import { getValue } from "@utils/lodash";

function EntityMappingDetailsSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path-entiy-details">
          <rect id="Rectangle_18173" data-name="Rectangle 18173" width="24" height="24" transform="translate(-10467 -6499)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_281" data-name="Mask Group 281" transform="translate(10467 6499)" clip-path="url(#clip-path-entiy-details)">
        <path id="do_not_disturb_on_FILL0_wght300_GRAD0_opsz24" d="M8.158-16.368h10v-1.579h-10Zm5,9.211a9.741,9.741,0,0,1-3.9-.787,10.1,10.1,0,0,1-3.176-2.137,10.1,10.1,0,0,1-2.138-3.174,9.732,9.732,0,0,1-.788-3.9,9.741,9.741,0,0,1,.787-3.9,10.1,10.1,0,0,1,2.137-3.176A10.1,10.1,0,0,1,9.257-26.37a9.732,9.732,0,0,1,3.9-.788,9.741,9.741,0,0,1,3.9.787,10.1,10.1,0,0,1,3.176,2.137,10.1,10.1,0,0,1,2.138,3.174,9.732,9.732,0,0,1,.788,3.9,9.741,9.741,0,0,1-.787,3.9,10.1,10.1,0,0,1-2.137,3.176,10.1,10.1,0,0,1-3.174,2.138,9.732,9.732,0,0,1-3.9.788Zm0-1.579a8.127,8.127,0,0,0,5.974-2.447,8.127,8.127,0,0,0,2.447-5.974,8.127,8.127,0,0,0-2.447-5.974,8.127,8.127,0,0,0-5.974-2.447,8.127,8.127,0,0,0-5.974,2.447,8.127,8.127,0,0,0-2.447,5.974,8.127,8.127,0,0,0,2.447,5.974A8.127,8.127,0,0,0,13.158-8.737ZM13.158-17.158Z" transform="translate(-10468.158 -6469.842)" fill="#dadce0"/>
      </g>
    </svg>

  );
}

export default EntityMappingDetailsSvgComponent;
